module.exports = __webpack_public_path__ + "img/dots.6d6fc2af.svg";